   import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { message ,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker   } from 'antd';
import { PlusOutlined,PictureOutlined,VideoCameraOutlined,FileOutlined,CloseOutlined } from '@ant-design/icons';

import ModalImage from "react-modal-image";
import axios from 'axios';
import $ from 'jquery';

import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import person from '../../assets/images/icon/person.png';
import correct from '../../assets/images/icon/correct.png';
import wrong from '../../assets/images/icon/wrong.png';


const { TextArea } = Input;
const { Panel } = Collapse;
const storedFiles=[];

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}



function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			value: '',
			title: '',
			children_id: 1,
			details: '',
			image: '',
			video: '',
			file: '',
			loading: false,
  		    iconLoading: false,
  		    is_important: 0,
  		    is_archive: 0,
  		    school_id: '',
  		    details: '',
  		    school_list: [],
			previewImage: '',
			previewTitle: '',
			previewVisible: false,
			file_list: [],
		}
		this.handleSubmit = this.handleSubmit.bind(this);
		this.goBack = this.goBack.bind(this);
	}
	
	handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
      previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
    });
  };

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],id : this.props.match.params.id,school_id : storedArray['data'][0]['school_id'] });
		this.checkData()
		}
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			let program_id = this.props.match.params.id;
			var app = {user_id : user_id,id:program_id,school_id:school_id}
			getData('erp/parents_note_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
						});
					}else{
						this.setState({
							school_list: [],
							
						});
					}
				}
			});
	}
  }
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	};
  
  handleSubmit=(e)=>{
    e.preventDefault();
	if(localStorage.getItem('schoolData')){
    this.setState({ loading: true });
    
      getData('erp/parents_note_admin_reply',this.state).then((result) => {
      if(result.status==400){
             message.config({ top: 150});
			message.error('Please Insert All Field',2);
			this.setState({ loading: false });
          }
          if(result.status==200){
		    const data = new FormData() ;
            message.config({ top: 150});
            message.success('Message Send !!',2);
              this.setState({ loading: false });
              this.setState({comment_text:'',details:''});
              // window.location.reload(false);
              //this.checkdata();
			   if(document.getElementById('details')){
							document.getElementById('details').value = "";
				}
				const selectedFiles = this.state.file_list;
				const image = [] ;
				if(selectedFiles.length == 0){
					data.append(`image[0]`, '[]')
				}
				for (let i = 0; i < selectedFiles.length; i++) {
					data.append(`image[${i}]`, selectedFiles[i].selectedFiles)
				}
				data.append('id', result.id);	 
				data.append('user_id', this.state.user_id)
				let url = "https://kcisapi.kidzonia.co.in/v1/erp/upload_parents_notes";
				axios.post(url, data, {
				})
				.then(res => {
					this.setState({ loading: true });
					   message.config({ top: 150});
					   message.success('Message Send !!',2);
					   this.setState({ loading: false });
					   window.location.reload(false);		
				});
				this.setState({file_list:[]});
			  setTimeout(() => {
				this.checkData();
				}, 100);

          }
      });
	  }else{
		message.error('Please Login',2);	
	  }

  }	
  
  goBack(){
		window.location.href = '/parent-notes/index';
	}
	
	
	
	handleFileSelect = (e) =>{
		var files = e.target.files;		
		
		var people = [];
	
		
		var filesArr = Array.prototype.slice.call(files);
		filesArr.forEach(function (f) {   
	
			if (storedFiles.length > 3) {
				message.config({ top: 150});
				message.error('Sorry!..You can upload maximum 10 files at a time',2);
			} else {
				var _size = f.size;
				if (_size > 4100000) {
					message.config({ top: 150});
					message.error("Sorry!..You Can't Upload more then 4MB!",2);
					return false;
				}
				
				var reader = new FileReader();
				reader.onload = function (e) {
					var name = f.type;
					var t = name.toString().split('/');
					//if (t[0] === 'image') {
						var app = {
							file_name: f.name,
							file_url: e.target.result,					
							file_type: 'image',
							selectedFiles: f
						}
						storedFiles.push(app);
						people.push(f);
					// }				
				}
				reader.readAsDataURL(f);
			}
		});
		setTimeout(() => {
			this.setState({file_list:storedFiles});
			console.log(storedFiles);
		}, 500);
	} 

	removeFile= (file,e) =>{
		for (var i = 0; i < storedFiles.length; i++) {
			if (storedFiles[i].file_name === file) {
				storedFiles.splice(i, 1);
				break;
			}
		}
		setTimeout(() => {			
			if (storedFiles.length=='0') {
				const file = document.querySelector('.file');
				file.value = '';
			}			
			this.setState({file_list:storedFiles});
			//console.log(storedFiles);
		}, 500);
	}


	render()

	{
	const { previewVisible, previewImage, fileList, previewTitle } = this.state;
	const { size } = this.state;
	const content = (
					  <div>
						<p className="center upload-img">
						
						</p>
					  </div>
					);
	const radioStyle = {
		  display: 'block',
		  height: '30px',
		  lineHeight: '30px',
		};				
					
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		 <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     
					 <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Parent Note Details</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
						   <li class="breadcrumb-item"><a href="/parent-notes/index">Parent Notes</a>
                           </li>
                           <li class="breadcrumb-item active">Details
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
            
			{this.state.school_list.map((data) => (	
			<div class="col s12 m12 ex-padd">
            <div class="container ">
			   <div class="col s12 m12 mb-20 mt-10 card-content iq-card">
                  <section class="invoice-list-wrapper section food">
					
					<div class="desktop-view">
						<div class="col s12 m12 mb-20 pb-20 add-notice iq-card2 flow-root">
							<div class="row">
							<div class="col m12 s12 bb pb-10">
								<h6><b>Type : {data.note_type}</b></h6>
								{(() => {
											if (data.note_type =='leave') {
												return (
									<div class="notes-desc">From : {data.start_date} To : {data.end_date}</div>
									 )	
												}
											})()}
							</div>
						{data.chat.map((list) => (	
							
							(() => {
							if (list.type =='parent') {
							return (
							<div class="col m12 s12 bb pb-10 mt-10">
								<div class="col m1 s12 center title pt-10 no-padd">
									<img src={person} class="atd-img w-30" />
									<span><b>{list.name}</b></span>
								</div>
								<div class="col m10 s12 title">
									
									<div class="notes-desc">{list.text}</div>
									
									    {(() => {
												if (list.image_url!='') {
													return (
													
															<div class="note_img">
															{list.image_url.map((images)=> (
																<ModalImage small={images} large={images} hideDownload="true" />
															))}	
															</div>
													)
												}
											})()}	
									<div class=""><span>{list.added_date}</span></div>
								</div>
								
							</div>
							 )	
							}else{
							return (
									<div class="col m12 s12 bb pb-10 mt-10 right text-right">
										
										<div class="col m11 s12 title">
											<div class="notes-desc">{list.text}</div>
											{(() => {
													if (list.note_type =='leave') {
														return (
											<div class="notes-desc"> {list.start_date} : To  {list.end_date} From :</div>
											 )	
														}
													})()}
											{(() => {
												if (list.image_url!='') {
													return (
													
															<div class="note_img">
																{list.image_url.map((images)=> (
																	<ModalImage small={images} large={images} hideDownload="true" />
																))}	
															</div>
													)
												}
											})()}		
											<div class=""> <span>{list.added_date}</span></div>
										</div>
										<div class="col m1 s12 center title pt-10 no-padd">
											<img src={person} class="atd-img w-30" />
											<span><b>{list.name}</b></span>
										</div>
										
									</div>
							)
							}
							})()		
							
						 ))}	
							
							
							
						{/*	<div class="col m12 s12 bb pb-20 mt-20">
								<div class="col m1 s12 center title pt-10">
									<img src={person} class="atd-img" />
									<span><b>Admin</b></span>
								</div>
								<div class="col m10 s12 title mt-10">
									<div class="notes-desc"><b>Reply : {admin_reply.details}</b></div>
									<div class="notes-desc">Date : {admin_reply.added_date}</div>
								</div>
								
							</div>	
						*/}	
							
								
							</div>
						</div>
						<div class="m12 s12 col meal mb-20 ">
							<div class="row">
							<div class="col m10 s10 hidden-xs">
							 <TextArea
							  placeholder="Reply Here !!"
							  autoSize={{ minRows: 2, maxRows: 6 }}
							  onChange={this.handleSizeChange} 
							  name="details"
							/>
							</div>
							<div class="col m2 image hidden-xs">
							<label tabindex="0" class="pointer" role="button" for="image">
									<img src={image} className="pointer"/>
									<input  onChange={this.handleFileSelect} class="file-upload__input file hide" type="file" name="files" id="image" accept="image/*" multiple="multiple" style={{display: 'none',opacity: '0'}}/> 
							</label>
											
							</div>
							
							</div>
						</div>
						<div class="m12 s12 col ant-upload-list ant-upload-list-picture-card pb-20">
							{this.state.file_list.map((img) => (
												<>
												{(() => {
												  return (
								
														<div class="ant-upload-list ant-upload-list-picture-card">
														<div class="ant-upload-list-item ant-upload-list-item-done">
														   <div class="ant-upload-list-item-info">
														  
																
																
															<ModalImage  small={img.file_url} large={img.file_url} hideDownload="true" />
															  <button class="remove" id='remove' data-file={img.file_name} onClick={this.removeFile.bind(this,img.file_name)} type='button' title='Remove'><CloseOutlined /></button>									

														</div>
														</div>
														</div>
												)						
												
												})()}
												</>
												))}
							</div>	
						<div class="col m12 s12 meal mb-20 center bt pt-20">
							 <Button className="cancel-btn large-btn" onClick={this.goBack}>Back</Button>
							 <Button className="snd-btn large-btn" onClick={this.handleSubmit} loading={this.state.loading}>Send</Button>
						</div>
					</div>

					<div class="mobile-view">
						<div class="col s12 m12 mb-20 pb-20 add-notice iq-card2 mh-600 notes flow-root">
							<div class="row">
							<div class="col m12 s12 bb mt-10 parent-notes-det">
								
										{(() => {
											if (data.note_type =='Leave') {
												return (
														<h6><b>Type : {data.note_type}</b>
														<div class="notes-desc">From : {data.start_date} To : {data.end_date}</div>
														</h6>
														
														 )	
												}else{
													return(
														<h6><b>Type : {data.note_type}</b></h6>
													)	
												}
											})()}
							</div>
							<div class="col m12 no-padd mt-40">
						{data.chat.map((list) => (	
							
							(() => {
							if (list.type =='parent') {
							return (
							<div class="col m12 s12 pb-20 mt-10 no-padd">
								<div class="col m1 s12 title pt-10 ">
									<img src={person} class="atd-img w-30 d-inline" />
									<span><b>{list.name}</b></span>
								</div>
								
									
									{(() => {
											if (list.text!='') {
												return (
												<div class="col m10 s12 title">
														<div class="notes-desc">{list.text}</div>
												</div>
												)
											}
									})()}
									{(() => {
											if (list.image_url!='') {
												return (
<div class="col m10 s12 title">
														<div class="note_img">
															{list.image_url.map((images)=> (
																<ModalImage small={images} large={images} hideDownload="true" />
															))}	
														</div></div>	
												)
											}
									})()}	
								<div class="col m10 s12 title">
									<div class="time"><span>{list.added_date}</span></div>
								</div>
								
							</div>
							 )	
							}else{
							return (
									<div class="col m12 s12 pb-20 mt-10 right text-right no-padd">
										<div class="col m1 s12 title pt-10">
											<img src={person} class="atd-img w-30 d-inline" />
											<span><b>{list.name}</b></span>
										</div>
										<div class="col m12 s12 title">
											
												{(() => {
											if (list.text!='') {
												return (
												
														<div class="col m10 s12 title"><div class="notes-desc">{list.text}</div></div>
												)
											}
									})()}
												{(() => {
													if (list.note_type =='leave') {
														return (
														<div class="col m10 s12 title"><div class="notes-desc"> {list.start_date} : To  {list.end_date} From :</div></div>
														 )	
													}
												})()}
												{(() => {
														if (list.image_url!='') {
															return (
<div class="col m10 s12 title">
																	<div class="note_img">
																		{list.image_url.map((images)=> (
																			<ModalImage small={images} large={images} hideDownload="true" />
																		))}	
																	</div></div>
															)
														}
												})()}	
											
											<div class="time"> <span>{list.added_date}</span></div>
										</div>
										
										
									</div>
							)
							}
							})()		
							
						 ))}	
						</div>	
								
							</div>
						</div>
						<div class="rcw-sender">
							<input type="text" id="details" defaultValue={this.state.details}  onChange={this.handleSizeChange}  class="rcw-new-message" name="details" placeholder="Type a message..." autocomplete="off"/>
							<div class="file_attach">
								<label for="file_upload"><i class="ri-attachment-2 rcw-send-icon"></i></label>
								<input accept="image/*"  capture="camera" id="file_upload" name="file_upload" type="file"/>
								<div class="ant-upload-list ant-upload-list-picture-card">
							
							</div>	
							</div>
							<button type="button"  onClick={this.handleSubmit} class="rcw-send">
								<i class="ri-send-plane-2-fill rcw-send-icon"></i>
							</button>
						</div>
					</div>	
					
					
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
         </div>
		 
		  ))}	
		
		 
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
